import { ReactElement, useRef, useState } from 'react'
import { clientInfo } from 'configureBrand'
import CobrowseIcon from 'syf-component-library/ui/icons/Cobrowse'
import { useLocation } from 'react-router-dom'
import i18n from 'lang/i18n'
import documents from 'const/documents'
import { shouldShowFooterCardInfo } from 'helpers/brandHelpers'
import routePaths from 'const/routePaths'
import { useCoBrowse } from 'ui/customHooks/useCoBrowse'
import { selectShowCoBrowse } from 'redux/config/configSlice'
import { useAppSelector } from 'redux/hooks'
import { AnalyticsEvent } from 'helpers/analytics'
import SecureSiteModal from './SecureSiteModal'
import {
  CardInformation,
  CardInformationMessage,
  CobrowseButton,
  Container,
  FooterWrapper,
  Link,
  LinkContainer,
  Text
} from './subcomponents'
import CoBrowseModal from '../CoBrowseModal'

const { websiteUsage, privacyPolicy, accessibility } = documents

const { clientName } = clientInfo

const Footer = (): ReactElement => {
  const location = useLocation()
  const [isSecureSiteModalOpen, setIsSecureSiteModalOpen] = useState(false)
  const isShowFooter = location.pathname !== routePaths.error
  const secureSiteFocusableRef = useRef<HTMLButtonElement>(null)

  const showCoBrowse = useAppSelector(selectShowCoBrowse)

  const {
    handleCoBrowseClick,
    handleCobrowseModalClose,
    handleCobrowseModalStart,
    isCoBrowseActive,
    showCobrowseModal
  } = useCoBrowse()

  return (
    isShowFooter && (
      <>
        <CoBrowseModal
          showModal={showCobrowseModal}
          startCobrowse={handleCobrowseModalStart}
          closeModal={handleCobrowseModalClose}
        />
        <Container id="footer">
          <FooterWrapper>
            <div>
              <Text aria-label={i18n({ modalsTitle: 'secureSite' }) as string}>
                {i18n(
                  { footer: 'secureButton' },
                  {
                    onClickHandler: () => setIsSecureSiteModalOpen(true),
                    secureSiteFocusableRef
                  }
                )}
              </Text>
              <LinkContainer>
                <Link
                  href={websiteUsage}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {i18n({ footer: 'websiteUsageAgreement' })}
                </Link>
                <Link
                  href={privacyPolicy}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {i18n({ footer: 'onlinePrivacyPolicy' })}
                </Link>
                <Link
                  href={accessibility}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {i18n({ footer: 'onlineAccessibility' })}
                </Link>
              </LinkContainer>
            </div>
            {isCoBrowseActive && showCoBrowse ? (
              <CobrowseButton
                buttonType="primary"
                onClick={handleCoBrowseClick}
                ariaLabel={i18n({ footer: 'startCobrowseSession' }) as string}
                data-object="image"
                data-reason="co-browser"
                data-type="footer"
                data-analytics={AnalyticsEvent.click}
              >
                <CobrowseIcon height={32} width={32} aria-hidden="true" />
              </CobrowseButton>
            ) : null}
          </FooterWrapper>
          {shouldShowFooterCardInfo(clientName) && (
            <CardInformation>
              <CardInformationMessage>
                {i18n({ footer: 'cardInformation' }) as string}
              </CardInformationMessage>
            </CardInformation>
          )}
        </Container>
        <SecureSiteModal
          isOpen={isSecureSiteModalOpen}
          setIsOpen={setIsSecureSiteModalOpen}
          secureSiteFocusableRef={secureSiteFocusableRef}
        />
      </>
    )
  )
}

export default Footer
